(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('GaeDeleteController',GaeDeleteController);

    GaeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Gae'];

    function GaeDeleteController($uibModalInstance, entity, Gae) {
        var vm = this;

        vm.gae = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Gae.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
